<mat-toolbar class="header">
  <div routerLink="/">
    <mat-icon class="home-icon">home</mat-icon>
    <div class="report-title">Portal Admin</div>
  </div>
  <div class="alle-logo">
    <a [href]="launchpadUrl" rel="noopener">
      <img class="logo" src="/assets/img/allegion-logo@1x.png" />
    </a>
  </div>
  <div class="links">
    <button
      type="button"
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="appMenu"
    >
      <div><i class="material-icons">person</i></div>
      <div>{{ "APP.profile" | translate }}</div>
    </button>
    <mat-menu #appMenu="matMenu">
      <div class="profile-header">
        <img
          *ngIf="userPicture"
          src="{{ userPicture }}"
          alt="profile picture"
        />
        {{ profile?.firstName }} {{ profile?.lastName }}
      </div>
      <!-- <div class="dropdown" (click)="$event.stopPropagation();">
        <mat-form-field>
          <mat-select 
            #language 
            placeholder="{{ 'APP.language' | translate }}" 
            (selectionChange)="toggleLanguage(language.value)">
            <mat-option value="en" (click)="menuTrigger.closeMenu()">English</mat-option>
            <mat-option value="fr" (click)="menuTrigger.closeMenu()">Français</mat-option>
            <mat-option value="es" (click)="menuTrigger.closeMenu()">Español</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
      <button
        mat-menu-item
        role="link"
        (click)="navigateToSpecialProgram()"
        routerLinkActive="active-link"
      >
        <mat-icon svgIcon="auth-seller" class="auth-seller"></mat-icon>
        {{ "SPECIAL.program" | translate }}
      </button>
      <button role="link" mat-menu-item (click)="navigateToHelp()">
        <mat-icon>live_help</mat-icon>
        <span>{{ "APP.help" | translate }}</span>
      </button>
      <button role="link" mat-menu-item (click)="openNoticesDialog()">
        <mat-icon>description</mat-icon>
        <span>{{ 'APP.notices' | translate }}</span>
      </button>
      <button class="signout" mat-menu-item (click)="signOut()">
        <mat-icon>power_settings_new</mat-icon>
        <span>{{ "APP.logout" | translate }} </span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>

<router-outlet></router-outlet>
